var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "8.46667mm",
    height: "38.099998mm",
    viewBox: "0 0 8.46667 38.099998",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-258.9)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.02355791,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0.98571424
    },
    d: "M 0,281.76 V 258.9 l 8.46667,15.24 V 297 Z",
    id: "rect936"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpRightArrow);
export default __webpack_public_path__ + "static/media/upRightArrow.23748f47ae00c8671d63948665abf248.svg";
export { ForwardRef as ReactComponent };